import React, { useEffect } from "react";
import Image64 from "../images/image 64.png";
import NavLink2 from "../compnents/NavLink2";
import Pin from "../images/Group337.png";
import Image18 from "../images/image 18-1.png";
import FixedIncome from "../images/FixedIncome.png";
import Maskgroup4 from "../images/Mask group4.png";
import Footer4 from "../compnents/Footer4";
import Image17 from "../images/image 17-1.png";
import Image19 from "../images/image 19-1.png";
import Image47 from "../images/image 47.png";
import { Link } from "react-router-dom";
import Right from "../images/right-arrow.png";
import Footer5 from "../compnents/Footer5";

function FixedIncomFundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div>
      <div className="main-MF"
        style={{
          backgroundImage: `url(${Pin})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          paddingBottom: ".3rem",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div>
          <NavLink2 />
          <h1 className="">Fixed Income Funds</h1>
          <div>
            <p className="text-white">TrustBanc Fixed Income Fund is registered with the Securities and Exchange Commission, Nigeria.</p>
          </div>
        </div>

      </div>
      <div className="mutual-cards">
        <h4 className="header4">Mutual Funds</h4>

        <div className="mutual-card1">
          <div className="mutual-img-holder">
            {" "}
            <img src={FixedIncome} alt="" className="mutual-img" />
          </div>
          <div className="mutual-info">
            <h4>TrustBanc Fixed Income Fund </h4>
            <p style={{ marginBottom: "0.5rem" }}>
              The TrustBanc Fixed-Income Fund (TFIF) is an open-ended mutual fund designed
              for investors seeking stable income, capital preservation, and long-term
              capital growth.
            </p>
            <p style={{ marginBottom: "0.5rem" }}>
              The Fund primarily invests in a diversified portfolio of high-rated fixed income
              securities, including FGN bonds, corporate bonds, money market instruments
              (Treasury bills and commercial paper), exchange-traded funds (ETFs), Real estate
              investment trust and other Collective Investment Schemes.
            </p>
            <p style={{ marginBottom: "1rem" }}>
              Targeted at moderately conservative investors, TFIF aims to deliver steady income and
              long-term capital appreciation, with returns benchmarked against the 3-year FGN Bond
              yield. Through active portfolio management and disciplined risk oversight, the Fund
              offers a reliable solution for individuals and institutions looking to optimize returns
              on a risk-adjusted basis.
            </p>

            <div className="row">
              <div className="col-sm-12 col-lg-6">
                <p style={{ marginBottom: "0.3rem" }} className="fw-bold">Fund Facts</p>
                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Benchmark: </p>
                <p style={{ marginBottom: "0.5rem" }} className="">
                  3-year Federal Government of Nigeria Bond.
                </p>

                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Minimum Investment Amount: </p>
                <p style={{ marginBottom: "0.5rem" }} className="">
                  N10,000.00
                </p>

                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Minimum Holding Period: </p>
                <p style={{ marginBottom: "0.5rem" }} className="">
                  90 Days
                </p>

                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Income Distribution: </p>
                <p style={{ marginBottom: "0.5rem" }} className="">
                  Bi-annually
                </p>

                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Risk: </p>
                <p style={{ marginBottom: "0.5rem" }} className="">
                  Medium
                </p>

                <p style={{ marginBottom: "0.1rem" }} className="fw-semibold">Management Fee: </p>
                <p style={{ marginBottom: "1rem" }} className="">
                  1.50%
                </p>
              </div>
              <div className="col-sm-12 col-lg-6">
                <p style={{ marginBottom: "0.3rem" }} className="fw-bold">Other Benefits</p>
                <div className="mb-2">
                  <img src={Right} alt="" style={{ width: "20px" }} />
                  Capital Appreciation
                </div>

                <div className="mb-2">
                  <img src={Right} alt="" style={{ width: "20px" }} />
                  Liquidity and regular income stream
                </div>


                <div className="mb-2">
                  <img src={Right} alt="" style={{ width: "20px" }} />
                  Diversification
                </div>

                <div className="mb-2">
                  <img src={Right} alt="" style={{ width: "20px" }} />
                  Optimal Return
                </div>

                <div className="mb-2">
                  <img src={Right} alt="" style={{ width: "20px" }} />
                  Professional Management
                </div>

                <div className="mt-3">
                  <p className="fw-bold mb-2">Invest Now</p>
                  <p className="mb-1">Download TrustBanc Prime Pro:</p>
                  <div className="d-flex flex-column gap-1">
                    <a href="https://play.google.com/store/apps/details?id=com.prime.trustbancgroup" target="_blank" rel="noopener noreferrer">
                      Android
                    </a>
                    <a href="https://apps.apple.com/ng/app/trustbanc-prime-pro/id6739510806" target="_blank" rel="noopener noreferrer">
                      iPhone
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="service-grid mx-auto p-2  justify-content-center" >
          <div className="row mb-3" data-aos="zoom-in-up">
            {" "}
            <h3 style={{ fontSize: "20px", color: "black" }}>WE ALSO OFFER</h3>
            <div className="service-cards col-sm-12 col-lg-6">
              <h1 style={{}}>Wealth Management</h1>
              <div className="service-card1">
                <div className="service-img2">
                  <img src={Image17} alt="" className="w-100 h-100 rounded-xl" /></div>
                <div className="service-info">
                  <p>
                    Our investment advisory service provides financial
                    management and wealth advisory services to a wide range of
                    clients...{" "}
                    <button className="service-btn">
                      <Link to="/wealthmanagement" className="service-link">
                        Learn more
                      </Link>{" "}
                      <img src={Maskgroup4} alt="" className="more-img" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <div className="service-cards col-sm-12 col-lg-6">
              <h1 style={{}}>Portfolio Management</h1>
              <div className="service-card1">
                <div className="service-img2">
                  <img src={Image19} alt="" className="w-100 h-100 rounded-xl" /></div>
                <div className="service-info">
                  <p>
                    Our Private Portfolio Product gives our clients a competitive
                    advantage by providing them with tailor mage solutions and
                    investments products that suits their finacial goals.
                    <button className="service-btn">
                      <Link to="/portfoliomanagement" className="service-link">
                        Learn more
                      </Link>{" "}
                      <img src={Maskgroup4} alt="" className="more-img" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row"
            data-aos="zoom-in-up"
          >
            <div className="service-cards col-sm-12 col-lg-6">
              <h1 style={{}}>Research</h1>
              <div className="service-card1">
                <div className="service-img2">
                  <img src={Image47} alt="" className=" w-100 h-100 rounded-xl" />
                </div>
                <div className="service-info">
                  <p>
                    Research is our core tool to offer professional advice, we
                    rely on TrustBanc AM research findings to guide all our investment
                    actions on behalf of clients...{" "}
                    <button className="service-btn">
                      <Link to="/research" className="service-link">
                        Learn more
                      </Link>{" "}
                      <img src={Maskgroup4} alt="" className="more-img" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <div className="service-cards col-sm-12 col-lg-6">
              <h1 style={{}}>Alt Invest (Ethical Investment)</h1>

              <div className="service-card1">
                <div className="service-img2" >
                  <img src={Image64} alt="" className=" w-100 h-100 rounded-xl" /></div>
                <div className="service-info">
                  <p>
                    A special investment product offered to investors that want
                    to earn halal returns on their investments. The product is
                    guided by Islamic Commercial jurisprudence.{" "}
                    <button className="service-btn">
                      <Link to="/ethicalinvestment" className="service-link">
                        Learn more
                      </Link>{" "}
                      <img src={Maskgroup4} alt="" className="more-img" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div>
        <Footer5 />
      </div>
      <div className="footer-4">
        <Footer4 />
      </div>
    </div>
  );
}

export default FixedIncomFundPage;
